<div class="search-total">
  <div class="search-bar-input-container">
    <input #searchBox="" id="stingray-landing-searchbar" #searchBarInput="" type="text" class="search-bar-input basis-full" [placeholder]="placeholder()" [matAutocomplete]="auto" (keyup)="searchTerm.next($event.target.value)" (click)="inputClick();" autocomplete="off">

    @if (!loading) {
      <label for="stingray-landing-searchbar" class="search-icon">
        <mat-icon>search</mat-icon>
      </label>
    }

    @if (loading) {
      <mat-spinner class="search-bar-loader" diameter="24"></mat-spinner>
    }
  </div>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)" class="search-autocomplete">

    @if (isProfessional) {
      <div class="m2 flex justify-center content-center items-center">
        <mat-chip-listbox multiple="true">
          <mat-chip-option (click)="searchOptions.customers = !searchOptions.customers; research()" [selected]="searchOptions.customers"><span translate="">Customers</span></mat-chip-option>
          <mat-chip-option (click)="searchOptions.buildings = !searchOptions.buildings; research()" [selected]="searchOptions.buildings"><span translate="">Buildings</span></mat-chip-option>
          <mat-chip-option (click)="searchOptions.applications = !searchOptions.applications; research()" [selected]="searchOptions.applications"><span translate="">Applications</span></mat-chip-option>
          <mat-chip-option (click)="searchOptions.financings = !searchOptions.financings; research()" [selected]="searchOptions.financings"><span translate="">Financings</span></mat-chip-option>
          <mat-chip-option (click)="searchOptions.mortgages = !searchOptions.mortgages; research()" [selected]="searchOptions.mortgages"><span translate="">Ongoing mortgages</span></mat-chip-option>
          <mat-chip-option (click)="searchOptions.documents = !searchOptions.documents; research()" [selected]="searchOptions.documents"><span translate="">Documents</span></mat-chip-option>
          <mat-chip-option (click)="searchOptions.notes = !searchOptions.notes; research()" [selected]="searchOptions.notes"><span translate="">Notes</span></mat-chip-option>
        </mat-chip-listbox>
      </div>
      <mat-divider></mat-divider>
      <!-- Hidden element -->
      @if (!searched) {
        <mat-option style="display: none;">
        </mat-option>
      }
    }


    @if (searched && hasNoResults()) {
      <mat-option>
        <div class="flex justify-start content-center items-center flex-row">
          <span class="main bold black" translate="">Nothing found</span>
        </div>
      </mat-option>
    }

    @for (record of searchResults?.records; track record) {
      <!-- Customers -->
      @if (record.type === 'Customer') {
        <mat-option [routerLink]="['/customers/'+record.customerId+'/detail']" (click)="optionClick(record)" [value]="record.description">
          <div class="flex justify-start content-center items-center flex-row">
            <div class="main bold black flex flex-row justify-start content-center items-center h-full">
              <!-- Add the 'collaboration' class to the span element to indicate that it is a collab -->
              @if (record.subtype == 'Collaboration') {
                <span class="bg-gray p1 mr2 collaboration">
                  <mat-icon>people_outline</mat-icon>
                </span>
              }
              @if (record.subtype == 'Person') {
                <span class="bg-gray p1 mr2">
                  <mat-icon>person_outline</mat-icon>
                </span>
              }
              @if (record.subtype == 'Company') {
                <span class="bg-gray p1 mr2">
                  <mat-icon>business_center</mat-icon>
                </span>
              }
              <span>{{record.description}}</span>
            </div>
            <!-- <div >
            <a [routerLink]="['/customers/'+customer.id+'/buildings']" class="sub">
              <mat-icon class="icon-small">business</mat-icon>
              <span class="accent mat-body-2">{{customer.buildings}} <span translate>buildings</span></span>
            </a>
            <a [routerLink]="['/customers/'+customer.id+'/mortgages']" class="sub">
              <mat-icon class="icon-small">folder_open</mat-icon>
              <span class="accent mat-body-2">{{customer.mortgages}} <span translate>mortgages</span></span>
            </a>
          </div> -->
        </div>
      </mat-option>
    }
    <!-- Buildings -->
    @if (record.type === 'Building') {
      <mat-option [routerLink]="['/customers/'+record.customerId+'/buildings/'+record.id+'/detail']" (click)="optionClick(record)" [value]="record.description">
        <div class="flex justify-start content-center items-center flex-row">
          <div class="main bold black flex flex-row justify-start content-center items-center h-full">
            <span class="bg-gray p1 mr2">
              <mat-icon>business</mat-icon>
            </span>
            {{record.description}}
          </div>
          <div class="flex flex-row justify-start content-center items-center h-full">
            <!-- <span class="sub">
            <mat-icon class="icon-small">aspect_ratio</mat-icon>
            <span class="mat-body-2">{{building.surface}} m<sup>2</sup></span>
          </span> -->
          <a [routerLink]="['/customers/'+record.customerId+'/detail']" class="sub flex flex-row justify-start content-center items-center h-full">
            <mat-icon class="icon-small">person_outline</mat-icon>
            <span class="accent mat-subtitle-2 "><span>{{record.customerName}}</span></span>
          </a>
        </div>
      </div>
    </mat-option>
  }
  <!-- Mortgages -->
  @if (record.type === 'Mortgage') {
    <mat-option [routerLink]="['/customers/'+record.customerId+'/mortgages/'+record.id+'/detail']" (click)="optionClick(record)" [value]="record.description">
      <div class="flex justify-start content-center items-center flex-row">
        <div class="main bold black flex flex-row justify-start content-center items-center h-full">
          <span class="bg-gray p1 mr2">
            <mat-icon>folder_open</mat-icon>
          </span>
          {{record.description }}
        </div>
        <div class="flex flex-row justify-start content-center items-center h-full">
          <!-- <span class="sub">
          <mat-icon class="icon-small">account_balance</mat-icon>
          <span class="mat-body-2">{{mortgage.loan | currency:'EUR':'symbol':'1.0-0'}}</span>
        </span> -->
        <a [routerLink]="['/customers/'+record.customerId+'/detail']" class="sub flex flex-row justify-start content-center items-center h-full">
          <mat-icon class="icon-small">person_outline</mat-icon>
          <span class="accent mat-subtitle-2 "><span>{{record.customerName}}</span></span>
        </a>
      </div>
    </div>
  </mat-option>
}
<!-- Applications -->
@if (record.type === 'Application') {
  <mat-option [routerLink]="['/customers/'+record.customerId+'/applications/'+record.id+'/detail']" (click)="optionClick(record)" [value]="record.description">
    <div class="flex justify-start content-center items-center flex-row">
      <div class="main bold black flex flex-row justify-start content-center items-center h-full">
        <span class="bg-gray p1 mr2">
          <mat-icon>folder_open</mat-icon>
        </span>
        {{ record.description}}
      </div>
      <div class="flex flex-row justify-start content-center items-center h-full">
        <!-- <span class="sub">
        <mat-icon class="icon-small">account_balance</mat-icon>
        <span class="mat-body-2">{{application.loan | currency:'EUR':'symbol':'1.0-0'}}</span>
      </span> -->
      @if (isProfessional) {
        <a [routerLink]="['/customers/'+record.customerId+'/detail']" class="sub flex flex-row justify-start content-center items-center h-full">
          <mat-icon class="icon-small">person_outline</mat-icon>
          <span class="accent mat-subtitle-2 "><span>{{record.customerName}}</span></span>
        </a>
      }
      @if (!isProfessional) {
        <span class="sub flex flex-row justify-start content-center items-center h-full">
          <mat-icon class="icon-small">person_outline</mat-icon>
          <span class="accent mat-subtitle-2 "><span>{{record.customerName}}</span></span>
        </span>
      }
    </div>
  </div>
</mat-option>
}
<!-- Financings -->
@if (record.type === 'Financing') {
<mat-option [routerLink]="['/applications/start?financingId=' + record.Id ]" (click)="optionClick(record)" [value]="record.description">
      <div class="flex justify-start content-center items-center flex-row">
        <div class="main bold black flex flex-row justify-start content-center items-center h-full">
          <span class="bg-gray p1 mr2">
            <mat-icon>euro_symbol</mat-icon>
          </span>
          {{ record.description }}
        </div>
        @if (isProfessional) {
<a [routerLink]="['/customers/'+record.customerId+'/detail']" class="sub flex flex-row justify-start content-center items-center h-full">
          <mat-icon class="icon-small">person_outline</mat-icon>
          <span class="accent mat-subtitle-2 "><span>{{record.customerName}}</span></span>
        </a>
}
        <!-- <span *ngIf="!isProfessional && financing.customerType !== 'Prospect'" class="sub">
          <mat-icon class="icon-small">person_outline</mat-icon>
          <span class="accent mat-body-2 "><span>{{financing.customerName}}</span></span>
        </span> -->
      </div>
    </mat-option>
}

  
}

  <!-- Notes -->
  @for (note of searchResults?.notes; track note) {
<mat-option [routerLink]="['/customers/'+note.customerId+'/notes/' + note.noteId]">
      <div class="doc flex justify-start content-center items-center flex-row">
        <span class="bg-gray p1 mr2">
          <mat-icon>mode_edit</mat-icon>
        </span>
        <div class="main">
          @if (hasHighlightMatchOnField(note.highlights, 'content')) {
          <div class="sub">
            <span [innerHTML]="getHighlightMatchOnField(note.highlights,'content')"></span>
          </div>
        }
      </div>
    </div>
  </mat-option>
}

<!-- Documents -->
@for (document of searchResults?.documents; track document) {
  <mat-option (click)="downloadDocumentFromResult(document)" [value]="document.originalFileName">
    <div class="doc flex justify-start content-center items-center flex-row">
      <span class="bg-gray p1 mr2">
        <mat-icon>insert_drive_file</mat-icon>
      </span>
      <div class="main">
        @if (hasHighlightMatchOnField(document.highlights, 'originalFileName')) {
          <div [innerHTML]="getHighlightMatchOnField(document.highlights,'originalFileName')" class="bold black">
          </div>
        }
        @if (!hasHighlightMatchOnField(document.highlights, 'originalFileName')) {
          <div class="bold black">
            {{document.originalFileName}}
          </div>
        }
        @if (hasHighlightMatchOnField(document.highlights, 'content')) {
          <div class="sub">
            <span [innerHTML]="getHighlightMatchOnField(document.highlights,'content')"></span>
          </div>
        }
      </div>
    </div>
  </mat-option>
}
</mat-autocomplete>
</div>